// (c) chaehongee. Confidential and proprietary.

import { configureStore, combineReducers, createAction, type AnyAction } from '@reduxjs/toolkit'
import sessionReducer from './slices/sessionSlice'
import selectionReducer from './slices/selectionSlice'
import lorasReducer from './slices/lorasSlice'
import generationReducer from './slices/generationSlice'
import canvasReducer from './slices/canvasSlice'
import canvasPositionsReducer from './slices/canvasPositionsSlice'
import aiModelsReducer from './slices/aiModelsSlice'
import chatReducer from './slices/chatSlice'
import savedNodesReducer from './slices/savedNodesSlice'
import sessionTabsReducer from './slices/sessionTabsSlice'

// Single action to reset the entire Redux state to initial values
export const resetStore = createAction('root/reset')

const appReducer = combineReducers({
    session: sessionReducer,
    sessionTabs: sessionTabsReducer,
    selection: selectionReducer,
    loras: lorasReducer,
    generationParams: generationReducer,
    canvas: canvasReducer,
    canvasPositions: canvasPositionsReducer,
    aiModels: aiModelsReducer,
    chat: chatReducer,
    savedNodes: savedNodesReducer,
})

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
    if (resetStore.match(action)) {
        // Returning undefined lets each slice fall back to its initialState
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

export const store = configureStore({
    reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch